import { useQuery } from "react-query";

import {
  getClientCategories,
  getClientSubCategories,
} from "api/services/clients/clients";

interface IProps {
  selectedCategoryId?: number | null;
}

const useClientCategories = ({
  selectedCategoryId,
}: IProps) => {

  // CATEGORIES
  const {
    data: categoriesData,
    isLoading:
      categoriesLoading,
  } = useQuery(
    "client-categories",

    getClientCategories,
  );

  // SUB CATEGORIES
  const {
    data: subCategoriesData,
    isLoading:
      subCategoriesLoading,
  } = useQuery(
    [
      "client-sub-categories",
      selectedCategoryId,
    ],

    () =>
      getClientSubCategories(
        selectedCategoryId as number,
      ),

    {
      enabled:
        !!selectedCategoryId,
    },
  );

  return {
    categories:
      categoriesData?.data || [],

    subCategories:
      subCategoriesData?.data || [],

    categoriesLoading,

    subCategoriesLoading,
  };
};

export default useClientCategories;
